module.exports = __webpack_public_path__ + "01_short_grey.dcdd97e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_short_grey.png
// module id = rEiG
// module chunks = 0